export const extractBirthdateFromSAId = (idNumber: string): Date | null => {
  if (!idNumber || idNumber.length !== 13) {
    return null;
  }

  const yearPart = idNumber.substring(0, 2);
  const month = idNumber.substring(2, 4);
  const day = idNumber.substring(4, 6);

  const currentYear = new Date().getFullYear();
  const currentYearLastTwo = currentYear % 100;
  const year =
    parseInt(yearPart) <= currentYearLastTwo
      ? 2000 + parseInt(yearPart)
      : 1900 + parseInt(yearPart);

  const monthNum = parseInt(month);
  const dayNum = parseInt(day);

  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) {
    return null;
  }

  return new Date(year, monthNum - 1, dayNum);
};
